import { Routes, Route } from "react-router-dom";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Home from "./pages/Home";
import Sparsh from "./pages/Sparsh";
import Saharsh from "./pages/Saharsh";
import Aboutus from "./pages/Aboutus";
import Contactus from "./pages/Contactus";
import ScrollToTop from "./Components/ScrollToTop";
import ScrollToTopButton from "./Components/ScrollToTopButton";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sparsh" element={<Sparsh />} />
        <Route path="/saharsh" element={<Saharsh />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/contact" element={<Contactus />} />
      </Routes>

      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

export default App;